<img [src]="imageSrc$ | async" class="img-fluid" [alt]="alt">
